import React from "react";
import { Line, Stack, Swatch } from "./TextLines.styles";
import type { TextLinesProps } from "./TextLines.types";

const HEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

/** A lead line and quieter lines under it, each with an optional icon or colour swatch. */
export const TextLines: React.FC<TextLinesProps> = ({ lines, className }) => (
  <Stack className={className}>
    {lines.map((line, index) => (
      <Line
        key={line.id}
        $lead={(line.emphasis ?? (index === 0 ? "lead" : "quiet")) === "lead"}
        $breakAnywhere={Boolean(line.breakAnywhere)}
        data-emphasis={line.emphasis ?? (index === 0 ? "lead" : "quiet")}
      >
        {line.icon ? (
          <span data-part="icon" aria-hidden="true">
            {line.icon}
          </span>
        ) : null}
        {line.swatch && HEX.test(line.swatch) ? <Swatch $color={line.swatch} aria-hidden="true" data-part="swatch" /> : null}
        <span>{line.text}</span>
      </Line>
    ))}
  </Stack>
);

export default TextLines;
